<template>
  <div class="account-balance">
    <AccountBalanceSkeleton :is-loading="!isBalanceDataReady">
      <UserAccountBalance
        :balance="getBalanceAmount"
        :credit-limit="getCreditLimit"
        :hide-balance="isBalanceHidden"
        @toggle-balance-visibility="toggleBalanceVisibility"
      />
    </AccountBalanceSkeleton>
    <Divider v-if="isMainPartner && !isBankPartner" type="vertical" class="divider" />
    <AccountBalanceSkeleton v-if="isMainPartner && !isBankPartner" :is-loading="!isBonusesDataReady">
      <UserBonusesBalance
        :balance="getBonusesAmount"
        :bonus-system-details-link="externalLinks.header.bonusSystemDetailsLink"
        :hide-balance="isBalanceHidden"
        @toggle-balance-visibility="toggleBalanceVisibility"
      />
    </AccountBalanceSkeleton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AccountBalanceSkeleton from '../account-balance-skeleton';
import UserAccountBalance from '../user-account-balance';
import UserBonusesBalance from '../user-bonus-balance';
import { accountBalanceConfig, externalLinks } from '@/features/account-balance/config';
import { balanceFormatter } from '@/shared/lib/balance';
import { Divider } from '@/shared/ui/divider';

export default {
  data() {
    return {
      periodicTimer: null,
    };
  },
  created() {
    this.fetchUserAccountBalance();
    this.periodicTimer = setInterval(() => {
      this.fetchUserAccountBalance();
    }, accountBalanceConfig.checkoutInterval);
  },
  beforeDestroy() {
    clearInterval(this.periodicTimer);
  },
  components: { UserAccountBalance, UserBonusesBalance, Divider, AccountBalanceSkeleton },
  mixins: [ balanceFormatter ],
  computed: {
    ...mapGetters('accountBonusesModule', ['isBonusesDataReady', 'getBonusesAmount']),
    ...mapGetters('accountBalanceModule', ['isBalanceDataReady', 'isBalanceHidden', 'getBalanceAmount', 'getCreditLimit']),
    ...mapGetters('currentUserModule', ['isMainPartner', 'isBankPartner']),
    externalLinks() {
      return externalLinks;
    }
  },
  methods: {
    ...mapActions('accountBalanceModule', ['fetchUserAccountBalance', 'hideBalance']),
    toggleBalanceVisibility() {
      this.hideBalance(!this.isBalanceHidden);
    },
  },
};
</script>

<style lang="scss" scoped>
.account-balance {
  display: flex;
  align-items: center;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 7px 8px;
  width: fit-content;
}

.divider {
  height: 24px !important;
  margin: 0 16px !important;
}
</style>
